
export function saveDr(taskId:number, inputId:number, input:HTMLElement){

    const labels = $(input).find(".label-item");
    const givenAnswers = [];

    labels.each((ind, obj) => {

        const target = $(obj).find(".drag-target");
        const index = Number(target.attr('data-index'));

        const answerLabel = $(input).find(".drag-drop[data-target=" + index + "]");
        if (answerLabel.length === 1){
            const answerIndex = Number(answerLabel.attr('data-id'));

            givenAnswers.push({
                answer: answerIndex,
                value: answerLabel.html() // maybe unnecessary
            })
        } else {
            givenAnswers.push({
                answer: 0
            })
        }

    });

    return {answer: givenAnswers};

}